import React, { useState, useEffect, useContext } from "react";
import MobileSidebar from "./MobileSidebar";
import { Link } from "react-router-dom";
import { getItemStorage } from "../../../Localstorage/useLocalStorage";
import Loading from "../../shared/Loading";

// img
import logo from "../../../images/header-logo.png";

// context
import { UserData } from "../../../contexts/UserInfoContext";
import { CartDataContext } from "../../../contexts/CartContext";

// functions
import { toFarsiNumber } from "../../../helper/helper";

// icons
import { BiUser } from "react-icons/bi";
import { BsCart3 } from "react-icons/bs";
import { compareDataContext } from "../../../contexts/CompareContext";
import { favouriteListContext } from "../../../contexts/FavouriteContext";

const MobileHeader = () => {
  const { user, userLoaded, err } = useContext(UserData);
  const { cart } = useContext(CartDataContext);
  const { compareData, openCompare, setOpenCompare } =
    useContext(compareDataContext);
  const { favouriteList } = useContext(favouriteListContext);

  const [open, setOpen] = useState(false);
  const [userLoading, setUserLoading] = useState(true);

  const token = getItemStorage("token");

  useEffect(() => {
    userLoaded && setUserLoading(false);
    err.msg && setUserLoading(false);
    !token && setUserLoading(false);
  }, [userLoaded, err]);

  return (
    <header className="w-full lg:hidden">
      <div className="w-full h-16 bg-[#151515] flex justify-between items-center px-3">
        <button
          className="w-10 h-10 bg-[#222] rounded-lg flex justify-center items-center"
          onClick={() => setOpen(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6 stroke-gray-200"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </button>

        {/* <Link to={"/"} className="text-xl font-black text-blue-600">
          یونی بست
        </Link> */}

        <div className="flex items-center flex-row-reverse gap-3">
          {/* <Link
            // to={user?.name ? "/user" : "/auth"}
            to={user.id && userLoading ? "" : user.id ? "/user" : "/auth"}
            className="cart flex items-center justify-center text-white w-10 h-10 bg-gradient-to-tl from-teal-600 to-teal-300 transition-all duration-300 rounded-xl shadow-lg shadow-blue-100"
          >
            {userLoading ? (
              <Loading
                color={"before:bg-white"}
                beforeWidth={"before:!w-2"}
                beforeHeight={"before:!h-2"}
                width={"!w-2"}
              />
            ) : !userLoading && user.id ? (
              <BiUser className="text-white stroke-[0.2px] min-w-[30px] text-[22px]" />
            ) : (
              <BiUser className="text-white stroke-[0.2px] min-w-[30px] text-[22px]" />
            )}
          </Link> */}

          <Link
            to="/cart"
            className="cart relative w-10 h-10 bg-gradient-to-tl from-yellow-900 to-yellow-500 shadow-lg rounded-xl flex justify-center items-center group"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.7"
              stroke="currentColor"
              className="w-6 h-6 stroke-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
              />
            </svg>

            <span className="absolute text-xs bottom-1 right-1 flex justify-center items-center w-4 h-4 bg-white text-yellow-600 rounded-full">
              {cart.items ? toFarsiNumber(cart.items.length) : toFarsiNumber("0")}
            </span>
          </Link>

          {/* favourite */}
          <Link
            to="/favourite"
            className={`favorite w-10 h-10 shadow-lg bg-gradient-to-tl from-red-600 to-red-300 rounded-xl flex justify-center items-center group relative`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-7 h-7 stroke-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
              />
            </svg>

            <span className="absolute bottom-1 right-1 flex justify-center items-center w-4 h-4 bg-white text-red-500 rounded-full">
              {toFarsiNumber(favouriteList.length)}
            </span>
          </Link>
        </div>
      </div>

      {/* sidebar */}
      <MobileSidebar open={open} setOpen={setOpen} />
    </header>
  );
};

export default MobileHeader;
